/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs */

const en_cv_extract_form_practicalexperiences_description_placeholder1 = /** @type {(inputs: Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please describe your practical experience`)
};

const de_cv_extract_form_practicalexperiences_description_placeholder1 = /** @type {(inputs: Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte beschreiben Sie Ihre praktische Erfahrung`)
};

/**
* | output |
* | --- |
* | "Please describe your practical experience" |
*
* @param {Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_practicalexperiences_description_placeholder1 = /** @type {((inputs?: Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Practicalexperiences_Description_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_practicalexperiences_description_placeholder1(inputs)
	return en_cv_extract_form_practicalexperiences_description_placeholder1(inputs)
});
export { cv_extract_form_practicalexperiences_description_placeholder1 as "cv_extract_form_practicalExperiences_description_placeholder" }